// Lyrics for each episode song, keyed by episode number.
// Paste the official words line by line; an empty list shows "Lyrics coming soon".
export const EPISODE_LYRICS = {
  1: [],
  2: [],
  3: [],
  4: [],
};

export const getEpisodeLyrics = (episodeNumber) => EPISODE_LYRICS[episodeNumber] || [];
